/* global wp_admin_ajax */

import AjaxUtils from './utils/ajax';

export default function initPanelNotifications() {
    if (document.querySelector('.panel-notifications')) {
        new PanelNotifications(document.querySelector('.panel-notifications'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class PanelNotifications {
    constructor($el) {
        this.$el = $el;
        this.$btnOpenPanel = document.querySelectorAll('.js-btn-open-panel-notifications');
        this.$btnClosePanel = this.$el.querySelectorAll('.js-btn-close-panel-notifications');
        this.init();
    }

    init() {
        // Panel notifications
        this.$btnOpenPanel.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.$el.classList.add('visible');
                // La cloche change d'état
                setTimeout(function() {
                    evt.target.classList.remove('is_new');
                }, 1000);
            });
        });

        this.$btnClosePanel.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.$el.classList.remove('visible');
                this.setNotifsRead();
            });
        });
    }

    setNotifsRead() {
        const args = new FormData();
        args.append('action', 'set_notifs_read');
        AjaxUtils.postData(wp_admin_ajax, args).then(response => {
            if (response.success) {
                // Les notifs ont été lues
                this.$el.querySelectorAll('.notif.is_new').forEach(notif => {
                    notif.classList.remove('is_new');
                });
            }
        });
    }
}
